import React from 'react'
import Answer from './Answer'
import { useDispatch, useSelector } from 'react-redux'
import { setAllQuestions } from '../../../../redux/slices'

const AnswersSummary = () => {
  const dispatch = useDispatch()
  const { questions: initQuestion } = useSelector(
    (state) => state.questionnaire,
  )
  const questions = initQuestion?.filter((q) => !q.isHide)

  const onUpdate = (question_id, answer) => {
    const updatedQuestions = initQuestion.map((q) =>
      q.id === question_id ? { ...q, answer: answer } : q,
    )
    dispatch(setAllQuestions(updatedQuestions))
  }
  return (
    <>
      {questions?.length > 0 && (
        <div className="w-full max-w-xl py-4">
          <ul className="space-y-2">
            {questions
              ?.filter((q) =>
                Array.isArray(q?.answer) ? q.answer.length > 0 : q?.answer,
              )
              ?.map((ans) => {
                if (!ans.id) return null
                return (
                  <li key={ans.id}>
                    <Answer answer={ans} onUpdate={onUpdate} />
                  </li>
                )
              })}
          </ul>
        </div>
      )}
    </>
  )
}

export default AnswersSummary
